import { render, staticRenderFns } from "./GiftcardPage.vue?vue&type=template&id=0b1da483&"
import script from "./GiftcardPage.vue?vue&type=script&lang=js&"
export * from "./GiftcardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports